import createPaginatedListReducerWithNamedType from 'store/hoReducers/paginatedList/reducer';
import { PURGE_ACTIONS } from 'store/services/project/actionTypes';
import initialState from './initialState';
import * as types from './actionTypes';

const reducerHandlers = (state = initialState, action = {}) => ({
  [PURGE_ACTIONS]: () => ({
    ...state,
    show: {
      ...state.show,
      data: !action.payload.data.intents.includes(state.show.data.id)
        ? state.show.data
        : {},
    },
  }),
  [types.PARTIAL_UPDATE_INTENT_REQUEST]: () => ({
    ...state,
    partialUpdate: {
      ...state.partialUpdate,
      isLoading: true,
    },
  }),
  [types.PARTIAL_UPDATE_INTENT_SUCCESS]: () => ({
    ...state,
    partialUpdate: {
      ...state.partialUpdate,
      isLoading: false,
    },
  }),
  [types.PARTIAL_UPDATE_INTENT_ERROR]: () => ({
    ...state,
    partialUpdate: {
      ...state.partialUpdate,
      isLoading: false,
      error: action.payload.error,
    },
  }),
  [types.TRAIN_REQUEST]: () => ({
    ...state,
    train: {
      ...state.train,
      isLoading: true,
    },
  }),
  [types.TRAIN_SUCCESS]: () => ({
    ...state,
    train: {
      ...state.train,
      isLoading: false,
      error: '',
    },
  }),
  [types.TRAIN_ERROR]: () => ({
    ...state,
    train: {
      ...state.train,
      isLoading: false,
      error: action.payload.error,
    },
  }),
});

export default createPaginatedListReducerWithNamedType(
  'INTENT',
  initialState,
  reducerHandlers,
);
